import { orderXClient } from '@/service/client'
import { unwrapServerMessage } from '@/service/server-message'
import { PublicAccountList } from '@/types/generated/common/account'
import {
  CreateAccountRequest,
  CreateAccountResponse,
  ServerMessage,
  UpdateAccountRequest,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function fetchUserAccounts() {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { getUserAccounts: {} })
    if (data.error) {
      return Promise.reject(data.error)
    }
    const userAccountsResponse = data.userAccountsResponse
    if (!userAccountsResponse) {
      return { accounts: [] } as PublicAccountList
    }
    return userAccountsResponse
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function createAccount(payload: CreateAccountRequest) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { createAccount: payload })
    const createAccountResponse = data.createAccountResponse as CreateAccountResponse
    return createAccountResponse
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function updateAccount(payload: UpdateAccountRequest) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { updateAccount: payload })
    return unwrapServerMessage(data)
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function disableAccount(accountId: string) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      updateAccount: { accountId, disabled: true },
    })
    return unwrapServerMessage(data)
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function cancelPendingAccount(accountId: string) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      cancelPendingAccount: { accountId },
    })
    if (data.error) {
      return Promise.reject(data.error)
    }
    return unwrapServerMessage(data)
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}
